// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.results-container[data-v-f6149722]{position:relative;top:-1px}`, "",{"version":3,"sources":["webpack://./vue/components/searchSelect/search-select.vue"],"names":[],"mappings":"AACA,oCACI,iBAAA,CACA,QAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
